export default __webpack_public_path__ + "static/media/IMG_1591.1b609699.jpeg";